import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "@/auth/session";

export default function LecturasPage() {
  const navigate = useNavigate();
  const { hasModule } = useSession();

  const modulos = useMemo(
    () =>
      [
        {
          label: "Control de Lecturas",
          icon: "ri-dashboard-line",
          desc: "Gestion operativa de lecturas de medidor",
          color: "text-sky-600",
          bg: "bg-sky-50",
          count: "Abrir modulo",
          path: "/control-lecturas",
          visible: hasModule("control_lecturas"),
        },
        {
          label: "Importar Lecturas",
          icon: "ri-upload-cloud-2-line",
          desc: "Carga masiva de lecturas desde archivo",
          color: "text-emerald-600",
          bg: "bg-emerald-50",
          count: "Carga masiva",
          path: "/importar-lecturas",
          visible: hasModule("control_lecturas"),
        },
        {
          label: "Lecturas del Periodo",
          icon: "ri-file-list-3-line",
          desc: "Consulta y analisis de lecturas procesadas",
          color: "text-violet-600",
          bg: "bg-violet-50",
          count: "Ver periodo",
          path: "/lecturas-periodo",
          visible: hasModule("control_lecturas"),
        },
        {
          label: "Seguimiento en Terreno",
          icon: "ri-radar-line",
          desc: "Seguimiento operativo de trabajo en campo",
          color: "text-amber-600",
          bg: "bg-amber-50",
          count: "Ver seguimiento",
          path: "/seguimiento-terreno",
          visible: hasModule("reportes"),
        },
      ].filter((item) => item.visible),
    [hasModule],
  );

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-bold text-gray-800">Lecturas</h1>
        <p className="mt-0.5 text-sm text-gray-500">Accesos operativos y de seguimiento del modulo de lecturas</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {modulos.map((m) => (
          <div
            key={m.label}
            onClick={() => navigate(m.path)}
            className="cursor-pointer rounded-xl border border-gray-100 bg-white p-6 transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-200"
          >
            <div className={`mb-4 flex h-12 w-12 items-center justify-center rounded-xl ${m.bg}`}>
              <i className={`${m.icon} text-2xl ${m.color}`} />
            </div>
            <div className="flex items-start justify-between">
              <div>
                <h3 className="mb-1 text-base font-semibold text-gray-800">{m.label}</h3>
                <p className="mb-3 text-sm text-gray-500">{m.desc}</p>
              </div>
              <i className="ri-arrow-right-line mt-0.5 text-gray-300" />
            </div>
            <span className="rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-600">{m.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}